import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/adminApi";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido al panel.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "No se pudo iniciar sesión.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-5">
      <div className="w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-brand-ink mb-6">
          <ArrowLeft className="h-4 w-4" /> Volver al sitio
        </a>
        <div className="rounded-3xl border border-gray-200 bg-white p-8 sm:p-10 shadow-xl shadow-brand-ink/5">
          <img src="/brand/logo.png" alt="MiMaquinaSegura.cl" className="h-11 w-auto" />
          <div className="mt-7 flex items-center gap-2 text-brand-ink">
            <Lock className="h-5 w-5 text-brand-yellow" />
            <h1 className="font-display text-xl font-bold text-brand-ink">Panel de administración</h1>
          </div>
          <p className="mt-2 text-sm text-gray-500">Ingresa con tu cuenta de administrador.</p>

          <form onSubmit={handleSubmit} noValidate className="mt-7 space-y-4" data-testid="admin-login-form">
            <div className="space-y-1.5">
              <Label htmlFor="email" className="text-sm font-medium text-brand-ink">Email</Label>
              <Input
                id="email"
                data-testid="admin-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@mimaquinasegura.cl"
                className="h-11 border-gray-300 focus-visible:ring-1 focus-visible:ring-brand-yellow"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password" className="text-sm font-medium text-brand-ink">Contraseña</Label>
              <Input
                id="password"
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="h-11 border-gray-300 focus-visible:ring-1 focus-visible:ring-brand-yellow"
              />
            </div>
            <Button
              type="submit"
              data-testid="admin-login-button"
              disabled={loading}
              className="w-full h-11 rounded-full bg-brand-ink hover:bg-brand-inkHover text-white font-semibold transition-all hover:-translate-y-0.5"
            >
              {loading ? <><Loader2 className="mr-2 h-5 w-5 animate-spin" /> Ingresando...</> : "Ingresar"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
